var _style, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiteArbre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Site",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17 17",
    style: {
      enableBackground: "new 0 0 17 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.stsitea0{fill:#605F71;}\r\n\t.stsitea1{fill:#FFFFFF;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "stsitea0",
    width: 4.1,
    height: 17
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 8.5,
    className: "stsitea0",
    width: 12.6,
    height: 8.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.4,
    className: "stsitea0",
    width: 4.1,
    height: 17
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.7,
    y: 5.7,
    className: "stsitea1",
    width: 1.7,
    height: 1.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7.7,
    y: 2.2,
    className: "stsitea1",
    width: 1.7,
    height: 1.7
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7.7,
    y: 12.9,
    className: "stsitea1",
    width: 1.7,
    height: 1.7
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 7.7,
    y: 9.3,
    className: "stsitea1",
    width: 1.7,
    height: 1.7
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9,
    className: "stsitea0",
    width: 4.1,
    height: 17
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1,
    y: 5.7,
    className: "stsitea1",
    width: 1.7,
    height: 1.7
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1,
    y: 2.2,
    className: "stsitea1",
    width: 1.7,
    height: 1.7
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1,
    y: 12.9,
    className: "stsitea1",
    width: 1.7,
    height: 1.7
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1,
    y: 9.3,
    className: "stsitea1",
    width: 1.7,
    height: 1.7
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 1.2,
    y: 5.8,
    className: "stsitea1",
    width: 1.7,
    height: 1.7
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 1.2,
    y: 2.2,
    className: "stsitea1",
    width: 1.7,
    height: 1.7
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 1.2,
    y: 12.9,
    className: "stsitea1",
    width: 1.7,
    height: 1.7
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 1.2,
    y: 9.3,
    className: "stsitea1",
    width: 1.7,
    height: 1.7
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    y: 16.5,
    className: "stsitea1",
    width: 17,
    height: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteArbre);
export default __webpack_public_path__ + "static/media/Site-arbre.1e64aec3b811e40730e2cefc81a9a721.svg";
export { ForwardRef as ReactComponent };